import { render } from "./BreadCrumb.html?vue&type=template&id=456b8ee2&external"
import script from "./BreadCrumb.js?vue&type=script&lang=js&external"
export * from "./BreadCrumb.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__